var map = {
	"./add_col_after.svg": "9aa0",
	"./add_col_before.svg": "3eee",
	"./add_row_after.svg": "d497",
	"./add_row_before.svg": "cfeee",
	"./bold.svg": "c9a0",
	"./checklist.svg": "8559",
	"./code.svg": "b9f9",
	"./combine_cells.svg": "fca4",
	"./delete_col.svg": "f16a",
	"./delete_row.svg": "333c",
	"./delete_table.svg": "558f",
	"./github.svg": "8211",
	"./hr.svg": "2e8e",
	"./image.svg": "4d12",
	"./italic.svg": "c9f2",
	"./link.svg": "7262",
	"./mention.svg": "c081",
	"./ol.svg": "1b7d",
	"./paragraph.svg": "eed1",
	"./quote.svg": "0b5e",
	"./redo.svg": "f76f",
	"./remove.svg": "8010",
	"./strike.svg": "e37a",
	"./table.svg": "1bc9",
	"./ul.svg": "ec4c",
	"./underline.svg": "9b4c",
	"./undo.svg": "f1b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";